// trainingAPI
//
// Formacion EDUCA360 K12: videos, guias PDF e informacion de uso de la
// plataforma. Solo LECTURA desde el portal (la gestion vive en el panel admin).
//
// Usa apiFetch para que la peticion lleve el Accept-Language de la sesion.

import { ENV } from "../Utils";
import { apiFetch } from "../Utils/apiFetch";

const ROUTE = "training-resource";

export class TrainingAPI {
  baseApi = ENV.BASE_API;

  /**
   * Lista paginada de recursos.
   * @param {string} accessToken
   * @param {object} opts { page, limit, type, search, audience }
   *   - type: 'video' | 'pdf' | 'info'
   *   - audience: 'teacher' | 'institution'
   * @returns {{ resources: array, pagination: object|null }}
   */
  async list(
    accessToken,
    { page = 1, limit = 10, type, search, audience } = {},
  ) {
    const qs = new URLSearchParams();
    qs.set("page", String(page));
    qs.set("limit", String(limit));
    if (type) qs.set("type", type);
    if (search) qs.set("search", search);
    if (audience) qs.set("audience", audience);

    const url = `${this.baseApi}/${ROUTE}?${qs.toString()}`;
    const response = await apiFetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();

    if (response.status !== 200) {
      throw new Error(result?.message || "Error obteniendo recursos");
    }

    return {
      resources: result?.data?.resources || [],
      pagination: result?.data?.pagination || null,
    };
  }
}
